exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n* DEFINE VARIABLES\n*/\n.header-table-validator[data-v-0a2c3699] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 40px;\n}\n.subHeader[data-v-0a2c3699] {\n  margin-top: 3px;\n}\n.content-header[data-v-0a2c3699] {\n  width: 250px;\n}\n.float-left[data-v-0a2c3699] {\n  float: left;\n}\n.float-right[data-v-0a2c3699] {\n  float: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a2c3699","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/subHeaders/globalSettings/SubHeaderGlobalSettings.vue
// module id = 2070
// module chunks = 1